import { Stack, styled } from "@mui/material";

export const ManualChargePostingApprovalWrapper = styled(Stack)(() => {
	return {
		gap: "var(--flex-gap)",
		overflow: "hidden",
		"& .manual-charge-posting-table-box": {
			marginBottom: "calc(var(--basic-margin) * 1)",
			"& .MuiTableContainer-root": {
				borderRadius: "16px",
				"& .MuiTableHead-root": {
					"& .MuiTableCell-root": {
						whiteSpace: "nowrap",
						minWidth: "200px",
					},
					"& .MuiTableCell-root:last-child": {
						minWidth: "150px",
						width: "25%",
					},
				},
			},
			"& .dropdown-modal": {
				position: "absolute",
				right: "calc(var(--basic-padding) * 1.5)",
				backgroundColor: "var(--light-color)",
				boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
				zIndex: 1,
				borderRadius: "8px",
				paddingTop: 0,
				paddingBottom: 0,
				marginTop: "calc(var(--basic-margin)/4)",
				overflow: "hidden",
				maxWidth: "250px",
				"& .MuiListItem-root": {
					padding: 0,
					"& .MuiListItemText-root": {
						fontSize: "16px",
					},
					"&:hover": {
						backgroundColor: "var(--diluted-primary-color)",
					},
				},
			},
		},
	};
});
